import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ReactPaginate from "react-paginate";
import {
  fetchBrands,
  fetchCategories,
  fetchHealthCategories,
  fetchProducts,
} from "../features/feature1/feature1API";
import Spinner from "react-bootstrap/Spinner";
import Cookies from "js-cookie";
import { finallogo } from "../imgUrl";

const Products = () => {
  const [products, setProducts] = useState([]);
  const [sortOption, setSortOption] = useState("");
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  // const [healthcategories, setHealthCategories] = useState([]);
  // const [selectedhealthCategories, setSelectedHealthCategories] = useState([]);
  const [cartQuantities, setCartQuantities] = useState({});
  const [inCart, setInCart] = useState({}); // State to track if a product is in the cart

  // const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const categoriesResponse = await fetchCategories();
        setCategories(categoriesResponse.data.data);

        const brandsResponse = await fetchBrands();
        setBrands(brandsResponse.data.data);

        // const healthcategoriesResponse = await fetchHealthCategories();
        // setHealthCategories(healthcategoriesResponse.data.data);

        await fetchPaginatedProducts(1);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const fetchPaginatedProducts = async (page) => {
    try {
      const productResponse = await fetchProducts(page);
      setProducts(productResponse.data.data);
      setFilteredProducts(productResponse.data.data);
      setTotalPages(productResponse.data.totalPages);
    } catch (error) {
      console.error("Error fetching paginated products:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const categoryParam = query.get("category");
    const brandParam = query.get("brand");
    // const healthcategoriesParam = query.get("healthCategory");

    if (categoryParam) setSelectedCategories([categoryParam]);
    if (brandParam) setSelectedBrands([brandParam]);
    // if (healthcategoriesParam)
    //   setSelectedHealthCategories([healthcategoriesParam]);
  }, [location.search]);

  useEffect(() => {
    const filterProducts = () => {
      if (
        selectedCategories.length === 0 &&
        selectedBrands.length === 0
        // selectedhealthCategories.length === 0
      ) {
        setFilteredProducts(products);
      } else {
        const filtered = products.filter((product) => {
          const categoryMatch =
            selectedCategories.length === 0 ||
            selectedCategories.includes(product.product_category_id);
          const brandMatch =
            selectedBrands.length === 0 ||
            selectedBrands.includes(product.brand_id);
          // const healthcategoriesMatch =
          // selectedhealthCategories.length === 0 ||
          // selectedhealthCategories.includes(product.health_category_id);
          return categoryMatch && brandMatch;
          // && healthcategoriesMatch
        });
        setFilteredProducts(filtered);
      }
    };

    filterProducts();
  }, [selectedCategories, selectedBrands, products]);
  // selectedhealthCategories,
  const handleCategoryChange = (categoryId) => {
    setSelectedCategories((prevState) =>
      prevState.includes(categoryId)
        ? prevState.filter((id) => id !== categoryId)
        : [...prevState, categoryId]
    );
  };

  const handleBrandChange = (brandId) => {
    setSelectedBrands((prevState) =>
      prevState.includes(brandId)
        ? prevState.filter((id) => id !== brandId)
        : [...prevState, brandId]
    );
  };

  // const handleHealthChange = (healthId) => {
  //   setSelectedHealthCategories((prevState) =>
  //     prevState.includes(healthId)
  //       ? prevState.filter((id) => id !== healthId)
  //       : [...prevState, healthId]
  //   );
  // };

  const handlePageChange = (selectedObject) => {
    setCurrentPage(selectedObject.selected);
    fetchPaginatedProducts(selectedObject.selected + 1);
  };

  const calculateDiscountedPrice = (variant) => {
    if (variant.discount && variant.discount.discount_type === "perc") {
      return variant.price * (1 - variant.discount.discount / 100);
    } else if (variant.discount && variant.discount.discount_type === "fixed") {
      return Math.max(0, variant.price - variant.discount.discount);
    }
    return variant.price;
  };

  const addToCart = (product) => {
    // const availableVariant = product.variants.find((v) => v.inStock);
    // if (!availableVariant) return;

    // const selectedVariant = product.variant[0];
    const selectedVariant = product.variants?.[0] || product.variant?.[0];

    const quantity = cartQuantities[product._id]
      ? cartQuantities[product._id]
      : 1;
    const cartItem = {
      id: product._id,
      title: product.title,
      isRequirePrescription: product.isRequirePrescription,
      variant: {
        id: selectedVariant._id,
        name: selectedVariant.name,
        size: selectedVariant.size,
        price: selectedVariant.price,
        discountedPrice: calculateDiscountedPrice(selectedVariant),
        discountDetails: selectedVariant.discount
          ? {
              discount: selectedVariant.discount.discount,
              discount_type: selectedVariant.discount.discount_type,
            }
          : null,
      },
      quantity: quantity,
      price: calculateDiscountedPrice(selectedVariant) * quantity,
      originalPrice: selectedVariant.price * quantity,
      image: product.mediaFiles?.[0]?.url || null,
      media_id: product.mediaFiles?.[0]?._id || null,
      discount_id: selectedVariant.discounted_id || null,
    };

    const currentCart = Cookies.get("cart")
      ? JSON.parse(Cookies.get("cart"))
      : [];

    const existingItemIndex = currentCart.findIndex(
      (item) =>
        item.id === cartItem.id && item.variant.id === cartItem.variant.id
    );

    if (existingItemIndex > -1) {
      currentCart[existingItemIndex].quantity += cartItem.quantity;
      currentCart[existingItemIndex].price += cartItem.price;
    } else {
      currentCart.push(cartItem);
    }

    Cookies.set("cart", JSON.stringify(currentCart), { expires: 7 });
    setInCart((prev) => ({ ...prev, [product._id]: true }));
    setCartQuantities((prevState) => ({
      ...prevState,
      [product._id]: (prevState[product._id] || 0) + 1,
    }));
  };

  // const calculateDiscountedPrice = (variant) => {
  //   if (variant.discount && variant.discount.discount_type === "perc") {
  //     return variant.price * (1 - variant.discount.discount / 100);
  //   } else if (variant.discount && variant.discount.discount_type === "fixed") {
  //     return Math.max(0, variant.price - variant.discount.discount);
  //   }
  //   return variant.price;
  // };

  // const addToCart = (product) => {
  //   // const availableVariant = product.variants.find((v) => v.inStock);
  //   // if (!availableVariant) return;

  //   const selectedVariant = product.variant[0];
  //   const quantity = cartQuantities[product._id] || 1;
  //   const cartItem = {
  //     id: product._id,
  //     title: product.title,
  //     isRequirePrescription: product.isRequirePrescription,
  //     variant: {
  //       id: selectedVariant._id,
  //       name: selectedVariant.name,
  //       size: selectedVariant.size,
  //       price: selectedVariant.price,
  //       discountedPrice: calculateDiscountedPrice(selectedVariant),
  //       discountDetails: selectedVariant.discount
  //         ? {
  //             discount: selectedVariant.discount.discount,
  //             discount_type: selectedVariant.discount.discount_type,
  //           }
  //         : null,
  //     },
  //     quantity: quantity,
  //     price: calculateDiscountedPrice(selectedVariant) * quantity,
  //     originalPrice: selectedVariant.price * quantity,
  //     image: product.mediaFiles?.[0]?.url || null,
  //     media_id: product.mediaFiles?.[0]?._id || null,
  //     discount_id: selectedVariant.discounted_id || null,
  //   };
  //   // const cartItem = {
  //   //   id: product._id,
  //   //   title: product.title,
  //   //   variant: {
  //   //     id: selectedVariant._id,
  //   //     name: selectedVariant.name,
  //   //     size: selectedVariant.size,

  //   //     price: selectedVariant.price,
  //   //     discountedPrice: calculateDiscountedPrice(selectedVariant),
  //   //     discountDetails: selectedVariant.discount
  //   //       ? {
  //   //           discount: selectedVariant.discount.discount,
  //   //           discount_type: selectedVariant.discount.discount_type,
  //   //         }
  //   //       : null,
  //   //   },
  //   //   quantity: quantity,
  //   //   price: calculateDiscountedPrice(selectedVariant) * quantity,
  //   //   image: product.mediaFiles.length > 0 ? product.mediaFiles[0].url : null,
  //   // };

  //   const currentCart = Cookies.get("cart")
  //     ? JSON.parse(Cookies.get("cart"))
  //     : [];

  //   const existingItemIndex = currentCart.findIndex(
  //     (item) =>
  //       item.id === cartItem.id && item.variant.id === cartItem.variant.id
  //   );

  //   if (existingItemIndex > -1) {
  //     currentCart[existingItemIndex].quantity += cartItem.quantity;
  //     currentCart[existingItemIndex].price += cartItem.price;
  //   } else {
  //     currentCart.push(cartItem);
  //   }

  //   Cookies.set("cart", JSON.stringify(currentCart), { expires: 7 });
  //   setInCart((prev) => ({ ...prev, [product._id]: true }));
  // };

  // Increment function
  const incrementQuantity = (productId) => {
    setCartQuantities((prevState) => {
      const newQuantity = (prevState[productId] ? prevState[productId] : 0) + 1;

      // Update the cart in cookies
      const currentCart = Cookies.get("cart")
        ? JSON.parse(Cookies.get("cart"))
        : [];
      const existingItemIndex = currentCart.findIndex(
        (item) => item.id === productId
      );

      if (existingItemIndex > -1) {
        currentCart[existingItemIndex].quantity = newQuantity;
        currentCart[existingItemIndex].price = calculateDiscountedPrice(
          currentCart[existingItemIndex].variant,
          newQuantity
        );
      }

      Cookies.set("cart", JSON.stringify(currentCart), { expires: 7 });

      return { ...prevState, [productId]: newQuantity };
    });
  };

  // Decrement function
  const decrementQuantity = (productId) => {
    setCartQuantities((prevState) => {
      const newQuantity = Math.max((prevState[productId] || 1) - 1, 0);

      // Update the cart in cookies
      const currentCart = Cookies.get("cart")
        ? JSON.parse(Cookies.get("cart"))
        : [];
      const existingItemIndex = currentCart.findIndex(
        (item) => item.id === productId
      );

      if (existingItemIndex > -1) {
        currentCart[existingItemIndex].quantity = newQuantity;
        currentCart[existingItemIndex].price = calculateDiscountedPrice(
          currentCart[existingItemIndex].variant,
          newQuantity
        );
      }

      Cookies.set("cart", JSON.stringify(currentCart), { expires: 7 });

      return { ...prevState, [productId]: newQuantity };
    });
  };
  const handleSortChange = (event) => {
    const { value } = event.target;
    setSortOption(value);

    let sortedProducts = [...filteredProducts];

    switch (value) {
      case "priceLowToHigh":
        sortedProducts.sort((a, b) => {
          const priceA = calculateDiscountedPrice(a.variant[0]);
          const priceB = calculateDiscountedPrice(b.variant[0]);
          return priceA - priceB;
        });
        break;
      case "priceHighToLow":
        sortedProducts.sort((a, b) => {
          const priceA = calculateDiscountedPrice(a.variant[0]);
          const priceB = calculateDiscountedPrice(b.variant[0]);
          return priceB - priceA;
        });
        break;
      case "betterDiscount":
        sortedProducts.sort((a, b) => {
          const discountA = a.variant[0]?.discount?.discount || 0;
          const discountB = b.variant[0]?.discount?.discount || 0;
          return discountB - discountA;
        });
        break;
      default:
        break;
    }

    setFilteredProducts(sortedProducts);
  };

  const addedCartItem = () => {
    const cart = Cookies.get("cart") ? JSON.parse(Cookies.get("cart")) : [];
    const cartData = cart?.filter((cartData) => cartData?.quantity > 0);
    const updatedInCart = {};
    cartData?.forEach((item) => {
      updatedInCart[item.id] = true;
    });
    setInCart(updatedInCart);
    const updatedCartQuantities = {};
    cartData?.forEach((item) => {
      updatedCartQuantities[item.id] = item.quantity;
    });
    setCartQuantities(updatedCartQuantities);
  };

  useEffect(() => {
    addedCartItem();
  }, []);

  return (
    <div className="pb-5">
      <div className="container">
        {loading && (
          <div className="text-center">
            <Spinner animation="border" role="status">
              <span className="sr-only"></span>
            </Spinner>
          </div>
        )}
        {!loading && (
          <>
            <div className="">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="sub-div">
                    <ul>
                      <li>
                        <Link href="#">Home</Link>
                      </li>
                      <li>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={8}
                          height={15}
                          viewBox="0 0 8 15"
                          fill="none"
                        >
                          <path
                            d="M1.53249 4.11249L2.19562 3.45L5.80749 7.06062C5.86571 7.11847 5.91192 7.18727 5.94345 7.26305C5.97498 7.33883 5.99121 7.4201 5.99121 7.50218C5.99121 7.58426 5.97498 7.66553 5.94345 7.74131C5.91192 7.81709 5.86571 7.88589 5.80749 7.94374L2.19562 11.5562L1.53312 10.8937L4.92312 7.50312L1.53249 4.11249Z"
                            fill="black"
                          />
                        </svg>
                      </li>
                      <li>
                        <Link href="#">All products</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="next-div">
                    <div className="next-inner">
                      <h1>All Products</h1>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={60}
                        height={4}
                        viewBox="0 0 60 4"
                        fill="none"
                      >
                        <line
                          y1={2}
                          x2={60}
                          y2={2}
                          stroke="#EE3137"
                          strokeWidth={4}
                        />
                      </svg>
                    </div>
                    <div>
                      <div>
                        <div>
                          <span>Sort By </span>
                          <select
                            value={sortOption}
                            onChange={(e) => handleSortChange(e)}
                            name="sort"
                          >
                            <option value="priceLowToHigh">
                              Price: Low to High
                            </option>
                            <option value="priceHighToLow">
                              Price: High to Low
                            </option>
                            <option value="betterDiscount">
                              Better Discount
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="row">
                      <div className="col-sm-4 col-lg-4 col-md-12">
                        <div className="line product-filter-line">
                          <h1>Filter By</h1>
                          <div className="accordion" id="accordionExample">
                            <div className="toggle-container accordion-item">
                              <h2
                                className="accordion-header toggle-header"
                                id="headingOne"
                              >
                                <button
                                  className="accordion-button"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseOne"
                                  aria-expanded="true"
                                  aria-controls="collapseOne"
                                >
                                  Category
                                  <label className="toggle-label">+</label>
                                </button>
                              </h2>
                              <div
                                id="collapseOne"
                                className="accordion-collapse collapse show toggle-content"
                                aria-labelledby="headingOne"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  <form>
                                    {categories.map((category) => (
                                      <div key={category._id}>
                                        <input
                                          type="checkbox"
                                          id={`category-${category._id}`}
                                          name={category.name}
                                          value={category._id}
                                          checked={selectedCategories.includes(
                                            category._id
                                          )}
                                          onChange={() =>
                                            handleCategoryChange(category._id)
                                          }
                                        />
                                        <label
                                          htmlFor={`category-${category._id}`}
                                        >
                                          {category.name .split('_') .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(' ')}
                                        </label>
                                        <br />
                                      </div>
                                    ))}
                                  </form>
                                </div>
                              </div>
                            </div>

                            <div className="toggle-container accordion-item">
                              <h2
                                className="accordion-header toggle-header"
                                id="headingTwo"
                              >
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseTwo"
                                  aria-expanded="false"
                                  aria-controls="collapseTwo"
                                >
                                  Brands
                                  <label className="toggle-label">+</label>
                                </button>
                              </h2>
                              <div
                                id="collapseTwo"
                                className="accordion-collapse collapse toggle-content"
                                aria-labelledby="headingTwo"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  <form>
                                    {brands.map((brand) => (
                                      <div key={brand._id}>
                                        <input
                                          type="checkbox"
                                          id={`brand-${brand._id}`}
                                          name={brand.name}
                                          value={brand._id}
                                          checked={selectedBrands.includes(
                                            brand._id
                                          )}
                                          onChange={() =>
                                            handleBrandChange(brand._id)
                                          }
                                        />
                                        <label htmlFor={`brand-${brand._id}`}>
                                          {brand.name}
                                        </label>
                                        <br />
                                      </div>
                                    ))}
                                  </form>
                                </div>
                              </div>
                            </div>

                            {/* <div className="toggle-container accordion-item">
                              <h2
                                className="accordion-header toggle-header"
                                id="headingThree"
                              >
                                <button
                                  className="accordion-button"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseThree"
                                  aria-expanded="true"
                                  aria-controls="collapseThree"
                                >
                                  Health Category
                                  <label className="toggle-label">+</label>
                                </button>
                              </h2>
                              <div
                                id="collapseThree"
                                className="accordion-collapse collapse  toggle-content"
                                aria-labelledby="headingThree"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  <form>
                                    {healthcategories.map((healthcategory) => (
                                      <div key={healthcategory._id}>
                                        <input
                                          type="checkbox"
                                          id={`healthcategory-${healthcategory._id}`}
                                          name={healthcategory.name}
                                          value={healthcategory._id}
                                          checked={selectedhealthCategories.includes(
                                            healthcategory._id
                                          )}
                                          onChange={() =>
                                            handleHealthChange(
                                              healthcategory._id
                                            )
                                          }
                                        />
                                        <label
                                          htmlFor={`healthcategory-${healthcategory._id}`}
                                        >
                                          {healthcategory.name}
                                        </label>
                                        <br />
                                      </div>
                                    ))}
                                  </form>
                                </div>
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-8 col-lg-8 col-md-12">
                        <div className="line-sub product-grid-col">
                          <div className="action row">
                            {loading ? (
                              <Spinner animation="border" />
                            ) : filteredProducts.length > 0 ? (
                              filteredProducts.map((product) => {
                                const originalPrice =
                                  product.variant[0]?.price || 0;
                                const discountPercentage =
                                  product.variant[0]?.discount?.discount || 0;
                                const discountedPrice =
                                  originalPrice -
                                  (originalPrice * discountPercentage) / 100;
                                const isInStock = product.variant[0]?.inStock;

                                return (
                                  <div
                                    className="a1 col-sm-3 col-lg-3 col-md-4 mb-5 position-relative"
                                    key={product._id}
                                  >
                                    <Link to={`/productdetails/${product._id}`}>
                                      <div className="product-image-box">
                                        <img
                                          src={
                                            product.mediaFiles.length > 0 &&
                                            product.mediaFiles[0]?.url
                                              ? product.mediaFiles[0].url
                                              : finallogo
                                          }
                                          alt={product.title}
                                        />
                                      </div>
                                      <h3>{product.title}</h3>
                                      <div className="inndr-main">
                                        <div className="inter">
                                          <Link href="#">
                                            ₹{discountedPrice.toFixed(2)}{" "}
                                            <del>(₹{originalPrice})</del>
                                          </Link>
                                        </div>
                                        <div className="otter">
                                          <Link href="#">
                                            {discountPercentage
                                              ? `${discountPercentage}% off`
                                              : "N/A"}
                                          </Link>
                                        </div>
                                      </div>
                                    </Link>
                                    <div className="quantity-control">
                                      {cartQuantities[product._id] ? (
                                        <div className="increment-decrement-buttons">
                                          <button
                                            onClick={() =>
                                              decrementQuantity(product._id)
                                            }
                                          >
                                            -
                                          </button>
                                          <span>
                                            {cartQuantities[product._id]
                                              ? cartQuantities[product._id]
                                              : 0}
                                          </span>
                                          <button
                                            onClick={() =>
                                              incrementQuantity(product._id)
                                            }
                                          >
                                            +
                                          </button>
                                        </div>
                                      ) : (
                                        <button
                                          onClick={() => addToCart(product)}
                                          className="ready"
                                        >
                                          ADD TO CART
                                        </button>
                                      )}
                                    </div>
                                    {/* <div className="quantity-control">
                                      {isInStock ? (
                                        inCart[product._id] ? (
                                          <div className="increment-decrement-buttons">
                                            <button
                                              onClick={() =>
                                                decrementQuantity(product._id)
                                              }
                                            >
                                              -
                                            </button>
                                            <span>
                                              {cartQuantities[product._id] || 1}
                                            </span>
                                            <button
                                              onClick={() =>
                                                incrementQuantity(product._id)
                                              }
                                            >
                                              +
                                            </button>
                                          </div>
                                        ) : (
                                          <button
                                            onClick={() => addToCart(product)}
                                            className="ready"
                                          >
                                            ADD TO CART
                                          </button>
                                        )
                                      ) : (
                                        <Link
                                          to={`/productdetails/${product._id}`}
                                          className="ready"
                                        >
                                          VIEW OPTION
                                        </Link>
                                      )}
                                    </div> */}
                                  </div>
                                );
                              })
                            ) : (
                              <p>No products available</p>
                            )}
                          </div>
                        </div>
                        {filteredProducts?.length > 0 && (
                          <ReactPaginate
                            previousLabel={"← Previous"}
                            nextLabel={"Next →"}
                            pageCount={totalPages}
                            onPageChange={handlePageChange}
                            containerClassName={"pagination"}
                            previousLinkClassName={"pagination__link"}
                            nextLinkClassName={"pagination__link"}
                            disabledClassName={"pagination__link--disabled"}
                            activeClassName={"pagination__link--active"}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Products;
